export default __webpack_public_path__ + "static/hcl_thumb-5281969a0067773af5f05e05c2756b83.png";